import React, {
	createContext,
	ReactNode,
	useContext,
	useEffect,
	useState,
} from 'react';
import { getUserId, getUserRole } from '../Utils/AuthUtil';

interface MainContextProps {
	isUnreadMsgInStudio: boolean;
	isUnreadMsgInChat: boolean;
	updateMsgStatus: (status: string) => void;
	fetchMsgDetails: () => void;
}

const MainContext = createContext<MainContextProps | undefined>(undefined);

interface MainContextProviderProps {
	children: ReactNode;
}

export const MainProvider: React.FC<MainContextProviderProps> = ({
	children,
}) => {
	const [isUnreadMsgInStudio, setIsUnreadMsgInStudio] = useState(false);
	const [isUnreadMsgInChat, setIsUnreadMsgInChat] = useState(false);

	useEffect(() => {
		if (parseInt(getUserRole()) !== 1000 && getUserId()) {
			fetchMsgDetails();
		}
	}, []);

	async function fetchMsgDetails() {
		// const id = getUserId();
		// const orgId = getAgencyId();
		// const data = await getUnreadMsgStatus(id ?? '', orgId ?? '');
		// setIsUnreadMsgInStudio(data.isUnreadMsgInStudio);
		// setIsUnreadMsgInChat(data.isUnreadMsgInStudio);
	}

	async function onUpdateMsgStatus(type: string) {
		// const id = getUserId();
		// const orgId = getAgencyId();
		// const data = await updateUnreadMsgStatus(id ?? '', orgId ?? '', type);
	}

	const updateMsgStatus = (type: string) => {
		if (type === 'Studio') {
			setIsUnreadMsgInStudio(false);
			onUpdateMsgStatus('Studio');
		} else if (type === 'Conversations') {
			setIsUnreadMsgInChat(false);
			onUpdateMsgStatus('Conversations');
		}
	};

	return (
		<MainContext.Provider
			value={{
				isUnreadMsgInChat,
				isUnreadMsgInStudio,
				updateMsgStatus,
				fetchMsgDetails,
			}}>
			{children}
		</MainContext.Provider>
	);
};

export const getMsgReadStatus = () => {
	const context = useContext(MainContext);

	return {
		isUnreadMsgInChat: context ? context.isUnreadMsgInChat : false,
		isUnreadMsgInStudio: context ? context.isUnreadMsgInStudio : false,
		updateMsgStatus: context ? context.updateMsgStatus : () => {},
		fetchMsgDetails: context ? context.fetchMsgDetails : () => {},
	};
};
